module.exports = "/packs/media/images/brands/vanguard-71bfcf2c3a93e4d69f10c25d941da0b2.png";